<template>
  <div>
    <b-row v-if="editable">
      <b-col cols="auto" class="ml-auto px-0 mr-3">
        <b-button 
          v-b-modal.delete-recipe-modal 
          variant="danger"
        >
          <b-icon icon="trash" /> Verwijder recept
        </b-button>
      </b-col>
    </b-row>

    <!-- Bevestigingsmodal voor het verwijderen van een recept -->
    <b-modal 
      id="delete-recipe-modal"
      title="Recept verwijderen" 
      hide-backdrop
      @ok="$emit('delete-recipe')"
    >
      <p class="my-1">
        Weet je zeker dat je het recept '{{ recipeName }}' wilt verwijderen?
      </p>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="primary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="danger" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'DeleteRecipeButton',
  props: {
    recipeName: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  }
};
</script>
